export const tableSettings = {
  maxHeight: 320,
  cellFontSize: 12,
  titleFontSize: 12,
  titleRowHeight: 50,
  allowEditBtn: true,
  tableRowHeight: 32,
  useMainColors: true,
  allowSelectAll: false,
  checkBoxCellWidth: 54,
  allowSelectItems: false,
  emptyListPadding: '10px 0',
  tableWrapperProps: { m: '2px' },
  checkBoxCellJustifyContent: 'flex-start',
};
